"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = template;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireDefault(require("react"));

var _input = _interopRequireDefault(require("../views/input"));

var _MonthPicker = _interopRequireDefault(require("../../MonthPicker"));

var _index = _interopRequireDefault(require("../style/index"));

var _ClickAwayListener = _interopRequireDefault(require("../../ClickAwayListener"));

var _renderprops = require("react-spring/renderprops");

var _createStyled = _interopRequireDefault(require("../../../utils/createStyled"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2["default"])([""]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])([""]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var Div = _createStyled["default"].div(_templateObject()),
    Picker = (0, _renderprops.animated)(_createStyled["default"].div(_templateObject2()));

function template() {
  var _this = this;

  var _this$props = this.props,
      minYear = _this$props.minYear,
      maxYear = _this$props.maxYear,
      allowedMonths = _this$props.allowedMonths,
      yearChange = _this$props.yearChange,
      deniedDates = _this$props.deniedDates,
      allowedDates = _this$props.allowedDates,
      isPeriod = _this$props.isPeriod,
      stringify = _this$props.stringify,
      value = _this$props.value,
      style = _this$props.style,
      _this$props$className = _this$props.className,
      className = _this$props$className === void 0 ? '' : _this$props$className,
      theme = _this$props.theme,
      rest = (0, _objectWithoutProperties2["default"])(_this$props, ["minYear", "maxYear", "allowedMonths", "yearChange", "deniedDates", "allowedDates", "isPeriod", "stringify", "value", "style", "className", "theme"]),
      _this$state = this.state,
      pickerPosition = _this$state.pickerPosition,
      active = _this$state.active,
      styles = this.compileStyled(_index["default"]);
  return _react["default"].createElement(Div, {
    styles: styles.root,
    className: className,
    ref: this.root
  }, _react["default"].createElement(Div, {
    styles: styles.wrapper,
    onMouseEnter: this._handleHover,
    onMouseLeave: this._handleRootBlur
  }, active ? _react["default"].createElement(_ClickAwayListener["default"], {
    node: this.root.current,
    onClickAway: this._handleBodyClick
  }) : null, _react["default"].createElement(_input["default"], (0, _extends2["default"])({}, rest, {
    onFocus: this._handleFocus,
    elementRef: this._inputRef,
    onBlur: this._handleBlur,
    value: stringify ? stringify(value) : value,
    palette: theme.palette
  })), _react["default"].createElement(Div, {
    styles: styles.calendar,
    onClick: this._handleCalendarClick
  }), _react["default"].createElement(_renderprops.Transition, {
    items: active,
    from: {
      opacity: 0.5,
      transform: 'scaleY(0)'
    },
    enter: {
      opacity: 1,
      transform: 'scaleY(1)'
    },
    leave: {
      opacity: 0,
      transform: 'scaleY(0)'
    },
    "native": true,
    config: {
      duration: 150
    }
  }, function (active) {
    return active && function (props) {
      return _react["default"].createElement(Picker, {
        styles: styles.picker,
        style: _objectSpread({}, props, {}, pickerPosition),
        ref: _this.picker
      }, _react["default"].createElement(_MonthPicker["default"], {
        deniedDates: deniedDates,
        allowedDates: allowedDates,
        isPeriod: isPeriod,
        allowedMonths: allowedMonths,
        minYear: minYear,
        maxYear: maxYear,
        yearChange: yearChange,
        value: value,
        onSubmit: _this._handleSubmit,
        onCancel: _this._handleCancel,
        stringify: stringify
      }));
    };
  })));
}